import React, {useEffect, useState} from 'react';
import {agregarEditarFeriado} from "../../redux/reducers/feriadosReducers";
import {Button, Dialog, DialogActions, DialogContent, Grid, TextField,} from "@mui/material";
import {useLocation, useNavigate} from "react-router-dom";
import LoadingProgress from "../../components/LoadingProgress";
import Strings from "../../assets/strings"
import {IFeriado} from "../../redux/types/IFeriado";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {DateInput} from "../../components/CustomTextField";

const initialState:IFeriado = {
    id: undefined, descripcion: "", fecha: ""
};
export default function Crear() {
    const navigate = useNavigate();
    let dispatch = useAppDispatch();
    const { status } = useAppSelector(state => state.feriados);

    const goBack = () => navigate(-1);
    const {state:urlState={}} = useLocation();


    const [state, setState] = useState(initialState);

    useEffect(() => {
        if(urlState?.feriado) {
            setState(state => ({...state, id:undefined}));
        }else {
            setState(initialState);
        }
    }, [setState, urlState]);

    const handleSubmit =  (e:React.FormEvent<HTMLFormElement>)  => {
        e.preventDefault();
        dispatch(agregarEditarFeriado(state))
    };

    return (
        <>
            <Dialog open={!!urlState?.feriado} onClose={goBack} maxWidth={"xs"} fullWidth={true}>
                    <DialogContent>
                        {(status === "loading") && <LoadingProgress />}
                        <form onSubmit={handleSubmit} id="form1">

                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <DateInput
                                        label={Strings.fecha}
                                        name="fecha"
                                        value={state.fecha ?? ""}
                                        required={true}
                                        onChange={(e: any) => setState({...state, fecha: e.target.value})}
                                        openTo={undefined} views={undefined} quincenalFijo={undefined}
                                        native={undefined} clearable={undefined}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        value={state.descripcion}
                                        onChange={(e) => setState({ ...state, descripcion: e.target.value })}
                                        inputProps={{maxLength: 50}}
                                        autoFocus
                                        required
                                        label={Strings.descripcion}
                                        type="text"
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>



                        </form>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={goBack} color="warning" variant={"text"}>{Strings.cancelar}</Button>
                        <Button type="submit" form={"form1"} color="primary" disabled={status === "loading"} variant={"outlined"}>
                            {!!state.id ? Strings.actualizar : Strings.guardar}
                        </Button>
                    </DialogActions>
            </Dialog>
        </>
    );

}
